export const CREATE_PARTIAL_USER = 'CREATE_PARTIAL_USER';
export const CREATE_PARTIAL_USER_SUCCESS = 'CREATE_PARTIAL_USER_SUCCESS';

// The components should not try to send these
export const CREATE_USER = 'CREATE_USER';
export const UPDATE_PARTIAL_USER = 'UPDATE_PARTIAL_USER';

// Use these for both of the above actions.
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';



// WEBPACK FOOTER //
// ./src/actionTypes/userActionTypes.js